import { render, staticRenderFns } from "./JohnDakaCoz.vue?vue&type=template&id=ff012594&"
import script from "./JohnDakaCoz.vue?vue&type=script&lang=ts&"
export * from "./JohnDakaCoz.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports